import React, { useEffect, useState } from 'react';
import { v4 } from 'uuid';
import { Chat, useChatAIMessages, genRandomId } from '@alife/chatai-ui';
import {
  chat,
  resumeConfirm,
  like,
  upload,
  queryHistory
} from '../../services/apiList';
import { ChatContentType } from '../../utils/constant';
import AiQuestionList from '../ai-question-list';
import AiPositionList from '../ai-position-list';
import AiResumeUpload from '../ai-resume-upload';
import AiAgreeCheck from '../ai-agree-check';

import './index.scss';

let uuid = null;
let chatId = null;

const config = {
  showNavBar: false
};

const AiAssistantCore = (props) => {
  const { mode } = props;
  const [disableInput, setDisableInput] = useState(false);
  const [waiting, setWaiting] = useState(false);
  const [loading, setLoading] = useState(false);

  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const { messages, appendMsg, updateMsg, prependMsgs } = useChatAIMessages({
    userAvatar:
      window?.__grayconfig?.avatar ||
      `https://${location.host}/file/download/?type=icon`,
    robotAvatar:
      'https://gw.alicdn.com/imgextra/i3/O1CN01usdTNF1F6ByIgYP7N_!!6000000000437-0-tps-72-72.jpg',
    showUser: true,
    showRobot: true
  });

  useEffect(() => {
    chatId = v4();

    if (mode === 'P') {
      setDisableInput(true);
    }
    try {
      uuid = localStorage.getItem('CN_CPO_TALENT_UUID');
      initQuestions(mode);
    } catch (e) {
      initQuestions(mode);
    }
  }, []);

  // 获取历史记录
  const handleRefresh = () => {
    return new Promise((resolve) => {
      queryHistory({
        deviceId: uuid,
        chatId,
        mode,
        pageSize,
        pageIndex
      }).then((resData) => {
        setPageIndex(pageIndex + 1);

        const list = [];
        resData?.forEach((item) => {
          list.push(handleChatResponse(item));
        });
        prependMsgs(list);

        resolve();
      });
    });
  };

  // 初始化问题列表
  const initQuestions = (key) => {
    // 咨询问题
    return appendMsg({
      _id: genRandomId(),
      content: {
        type: 'card',
        renderContent: () => {
          return (
            <AiQuestionList
              title={
                mode === 'Q' ? '常见问题' : '您可以选择以下方式智能推荐职位'
              }
              mode={mode}
              deviceId={uuid}
              chatId={chatId}
              handleClickQuestionItem={(v) => {
                handleSend('text', v, {});
                mode === 'P' && setDisableInput(false);
              }}
              hasRefresh={mode === 'Q'}
            />
          );
        },
        data: {
          needLike: false // 不传卡片updateMsg的时候会清空
        }
      },
      position: 'left'
    });
  };

  // 发送消息 给大模型
  const handleSend = (type, value, options) => {
    appendMsg({
      _id: genRandomId(),
      type,
      content: {
        text: value
      },
      position: 'right'
    });

    setLoading(true);
    setWaiting(true);

    chat({
      content: value,
      deviceId: uuid,
      chatId,
      mode
    })
      .then((resData) => {
        appendMsg(handleChatResponse(resData));
      })
      .finally(() => {
        setLoading(false);
        setWaiting(false);
      });
  };

  // 点赞/点踩
  const handleSupport = (msg, supportType) => {
    const { _id, type, data } = msg;

    if (data?.needLike) {
      like({
        deviceId: uuid,
        chatId,
        answerId: _id,
        likeType: supportType == 1 ? 'LIKE' : 'HATE',
        mode
      }).then((resData) => {
        updateMsg(_id, {
          _id,
          type,
          content: {
            ...msg,
            support: supportType
          },
          position: 'left'
        });
      });
    } else {
      updateMsg(_id, {
        _id,
        type,
        position: 'left',
        content: {
          ...msg,
          support: supportType
        }
      });
    }
  };

  // 根据接口返回的回答类型展示对应内容
  const handleChatResponse = (resData) => {
    const { id, contentType, tip, positionBeans, likeType, vectorId } = resData;
    let support = null;
    if (likeType === 'LIKE') {
      support = 1;
    } else if (likeType === 'HATE') {
      support = -1;
    }

    // 系统回答
    if (vectorId === 'SYSTEM') {
      // 普通回答 - 直接渲染内容
      if (contentType === ChatContentType.QUESTION_REQUIRE) {
        return {
          _id: id,
          content: {
            text: resData?.content,
            data: {
              needLike: true
            },
            support
          },
          position: 'left'
        };
      }
      // 职位要求
      if (contentType === ChatContentType.POSITION_REQUIRE) {
        return {
          _id: id,
          content: {
            type: 'card',
            renderContent: renderPositionRequirementCard,
            data: {
              needLike: true
            },
            support
          },
          position: 'left'
        };
      }
      // 推荐职位列表
      if (contentType === ChatContentType.POSITION_RECOMMEND) {
        return {
          _id: id,
          content: {
            type: 'card',
            renderContent: () => {
              return <AiPositionList tip={tip} list={positionBeans} />;
            },
            data: {
              needLike: true
            },
            support
          },
          position: 'left'
        };
      }
      // 简历流程
      if (contentType === ChatContentType.RESUME_FLOW) {
        const { resumeExist } = resData;
        // 已存在简历
        if (resumeExist) {
          return {
            _id: id,
            content: {
              type: 'card',
              renderContent: () => {
                return (
                  <AiAgreeCheck
                    handleConfirm={(v) => {
                      setLoading(true);
                      let tip = '系统正在快马加鞭为您推荐职位中...';
                      if (v === 'N') {
                        tip =
                          '很抱歉暂时未能帮您智能匹配职位，以下职位为热门职位，可以了解看看哈～';
                      }
                      appendMsg({
                        _id: genRandomId(),
                        content: {
                          type: 'text',
                          text: tip
                        },
                        position: 'left'
                      });

                      resumeConfirm({
                        option: v,
                        deviceId: uuid,
                        chatId,
                        mode
                      })
                        .then((data) => {
                          appendMsg(handleChatResponse(data));
                        })
                        .finally(() => {
                          setLoading(false);
                        });
                    }}
                  />
                );
              },
              data: {
                needLike: true
              }
            },
            position: 'left'
          };
        }

        // 未存在简历
        return {
          _id: id,
          content: {
            type: 'card',
            renderContent: () => {
              return (
                <AiResumeUpload
                  handleOssUploadSuccess={(fileKey, fileName) => {
                    setLoading(true);
                    appendMsg({
                      _id: genRandomId(),
                      content: {
                        type: 'text',
                        text: '正在快速匹配职位中，请稍后...'
                      },
                      position: 'left'
                    });
                    upload({
                      deviceId: uuid,
                      chatId,
                      fileKey,
                      fileName,
                      mode
                    })
                      .then((data) => {
                        appendMsg(handleChatResponse(data));
                      })
                      .finally(() => {
                        setLoading(false);
                      });
                  }}
                />
              );
            },
            data: {
              needLike: true
            }
          },
          position: 'left'
        };
      }
    } else {
      // 用户提问
      return {
        _id: id || genRandomId(),
        type: 'text',
        content: {
          text: resData?.content
        },
        position: 'right'
      };
    }
  };

  // 获取职位列表
  // const queryPositionList = (id) => {
  //   appendMsg({
  //     _id: id || genRandomId(),
  //     content: {
  //       type: 'card',
  //     },
  //     position: 'left',
  //   });
  // };

  // 简历上传
  // const handleUploadResume = () => {
  //   appendMsg({
  //     _id: genRandomId(),
  //     content: {
  //       type: 'card',
  //       renderContent: () => {
  //         // return <AiResumeUpload />;
  //         return <AiAgreeCheck />;
  //       },
  //     },
  //     position: 'left',
  //   });
  // };

  const renderPositionRequirementCard = () => {
    return (
      <div className="ai-position-requirement">
        <div>
          您可以直接输入您想要的职位要求或者关键字，系统会智能匹配职位哈～
        </div>
        <div className="ai-position-requirement-examples">
          <div>示例说明 找个杭州的财务实习岗位</div>
          <div>示例说明 想找个法国巴黎的产品运营岗位</div>
        </div>
      </div>
    );
  };

  return (
    <div className="ai-assistant-core">
      <Chat
        {...config}
        showSupport
        showLoadMore
        messages={messages}
        onSend={handleSend}
        onSupport={handleSupport}
        onRefresh={handleRefresh}
        disableInput={disableInput}
        waiting={waiting}
        loading={loading}
        // messages={messages}
        // waiting={waiting}
        // loading={loading}
        // onSend={handleSend}
        // onFlush={() => {
        //   resetList([]);
        // }}
      />
    </div>
  );
};

export default AiAssistantCore;
